import React from 'react'
import { connect } from 'react-redux'

class ReciboVendaUrbana extends React.Component {
  imprimir () {
    window.print()
  }

  render () {
    const venda = this.props.vendaUrbana

    if (!venda) {
      return (
        <div className="row internas">
          <p>Nenhuma venda urbana selecionada para impressão.</p>
        </div>
      )
    }

    const emp = this.props.empresaSelecionada || {}

    return (
      <div className="row internas">
        <style>{'@media print { .vx-no-print { display: none !important; } }'}</style>

        <div className="col-12">
          <div className="card vx-recibo-venda-urbana" style={{ maxWidth: 420, margin: '0 auto' }}>
            <div className="card-body">
              <h5 className="text-center mb-0">{emp.nomeFantasia || venda.nomeEmpresa}</h5>
              <p className="text-center text-muted mb-3"><small>Cupom - Venda Urbana</small></p>
              <hr/>

              <p className="mb-1">ID reserva: {venda.id}</p>
              <p className="mb-1">Itinerário: {venda.descricaoRotaItinerario}</p>
              <p className="mb-1">Data/hora partida: {venda.dataHoraPartidaItinerario}</p>
              <hr/>

              <p className="mb-1">Passageiro: {venda.nomePassageiro}</p>
              <p className="mb-1">RG: {venda.rg}</p>
              <p className="mb-1">Origem: {venda.cidadeOrigem}</p>
              <p className="mb-1">Destino: {venda.cidadeDestino}</p>
              <hr/>

              <p className="mb-1">Valor pago: R$ {venda.valor}</p>
              <p className="mb-1">Forma de pagamento: {venda.descricaoFormaPagamento}</p>
              <p className="mb-1">Data/hora da venda: {venda.dataHoraVenda}</p>
              <p className="mb-1">Vendedor: {venda.nomeVendedor}</p>
              {venda.situacao === 'CANCELADA' && (
                <p className="text-danger font-weight-bold">CANCELADA - {venda.motivoCancelamento}</p>
              )}
            </div>
          </div>

          <div className="text-center mt-3 vx-no-print">
            <button className="vx-btn-primary" onClick={() => this.imprimir()}>
              <i className="material-icons">print</i> Imprimir cupom
            </button>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  vendaUrbana: state.vendaUrbana,
  empresaSelecionada: state.empresaSelecionada
})

export default connect(mapStateToProps)(ReciboVendaUrbana)
